import { DeviceCounters } from "@services/devices/types";
import { useTranslation } from "react-i18next";
import { formatData } from "../utils";

export const useDeviceCountersFormatter = () => {
  const { t } = useTranslation();

  const getRealtimeDeviceCounters = (deviceCounters: DeviceCounters) => {
    const realTimeCard: RealTimeCardCommonProps = {
      dataType: t("devices"),
      loading: false,
    };

    const formatFn = (val?: number) =>
      val !== undefined ? formatData(val, `${val}`.length) : "";
    const path = "/assets/devices";
    const dataRoomsDevices: RealTimeDevicesDataProps[] = [
      {
        label: {
          text: t("link error"),
          color: "deckboard.lightblue.main",
        },
        data: {
          error: formatFn(deviceCounters.devicesUnreachable),
          total: deviceCounters.devicesTotal,
        },
        url: `${path}?status.reachable=false`,
      },
      {
        label: {
          text: t("login error"),
          color: "deckboard.lightblue.main",
        },
        data: {
          error: formatFn(deviceCounters.devicesLoginError),
          total: deviceCounters.devicesTotal,
        },
        url: `${path}?status.loginError=true`,
      },
      {
        label: {
          text: t("API error"),
          color: "deckboard.lightblue.main",
        },
        data: {
          error: formatFn(deviceCounters.devicesApiError),
          total: deviceCounters.devicesTotal,
        },
        url: `${path}?status.apiError=true`,
      },
    ];
    const data = { realTimeCard: realTimeCard, data: dataRoomsDevices };
    return data;
  };

  return { getRealtimeDeviceCounters };
};
